import * as React from "react";
import { useLocalStorage } from "react-use";

import { DOCUMENT_MAP_VIEW_MODES, type DocumentMapViewMode } from "./types";

const SPLIT_MIN_WIDTH = 1280;

/** The user's last view mode, else Split on a wide screen and List on a narrow one (SV-02, SV-03). */
export const useDocumentMapViewMode = (userId: string) => {
  // No initial value: react-use would store it, turning the width-based default into a choice.
  const [stored, setMode] = useLocalStorage<DocumentMapViewMode>(`drive.documentMapViewMode.${userId}`);
  const [defaultMode] = React.useState<DocumentMapViewMode>(() =>
    window.innerWidth >= SPLIT_MIN_WIDTH ? "split" : "list",
  );
  const mode = stored && DOCUMENT_MAP_VIEW_MODES.includes(stored) ? stored : defaultMode;
  return { mode, setMode };
};
